/**
 * State UI для взаимодейсвтиями с приложениями Vue
 */
const state = {
	/**
	 * Device by size
	 * @see widthForMobile
	 */
	isMobile: false,

	/**
	 * Device by user agent
	 */
	isMobileUA: false,

	/**
	 * true, если плотность пикселей экрана больше 1
	 */
	isRetina: false,

	/**
	 * true, елси это приложение
	 */
	isApp: false,

	/**
	 * true при горизонтальном расположении устройства
	 */
	isLandscape: true,

	/**
	 * true при вертикальном расположении устройства
	 */
	isPortrait: false,
	size: 0,

	// См. core.options
	dateFormat: 'Y-m-d',

	// См. core.options
	gmt: new Date().toString().match(/GMT(\S+)/)?.[1],
};

export default state;